import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
const initialState = {
    open: false,
    searchTerm: '',
};
/**
 * Allows a stockman to filter items in any list by `Ctrl+F` key press.
 */
const useCtrlFSearchPopoverStore = create()(immer((set) => ({
    ...initialState,
    openPopoverFilter: () => {
        set((state) => {
            state.open = true;
        });
    },
    closePopover: () => {
        set((state) => {
            state.open = initialState.open;
            state.searchTerm = initialState.searchTerm;
        });
    },
    setSearchTerm: (value) => {
        set((state) => {
            state.searchTerm = value;
        });
    },
    // resetCtrlFSearchPopoverState: () => {
    // 	set(initialState);
    // },
})));
export { useCtrlFSearchPopoverStore };
